<div class="flex justify-between gap-2 mb-3">
  <div class="flex gap-2 items-center">
    <label class="text-sm font-medium whitespace-nowrap">Usine</label>
    <p-select
      [options]="plantOptions"
      [(ngModel)]="selectedPlant"
      (onChange)="onPlantFilterChange($event.value)"
      (onClear)="onPlantFilterChange(null)"
      placeholder="Filtrer par usine"
      size="small"
      [showClear]="true"
      [style]="{ minWidth: '150px' }"
    ></p-select>
    <button
      pButton
      type="button"
      label="Effacer les filtres"
      class="p-button-sm"
      [ngClass]="
        hasActiveFilters
          ? '!bg-amber-500 !border-amber-500 hover:!bg-amber-600'
          : '!bg-gray-500/80 !border-gray-500/80 hover:!bg-gray-500/80'
      "
      (click)="onClearFilters()"
    >
      <i-lucide name="filter-x" [size]="16"></i-lucide>
    </button>
    <button
      pButton
      type="button"
      label="Ordres similaires"
      class="p-button-sm !bg-gray-500/80 !border-gray-500/80 hover:!bg-gray-500/80"
      (click)="filterBySimilarOrders()"
    >
      <i-lucide name="copy" [size]="16"></i-lucide>
    </button>
    <button
      pButton
      type="button"
      label="Priorités à revoir"
      class="p-button-sm !bg-gray-500/80 !border-gray-500/80 hover:!bg-gray-500/80"
      (click)="filterByPriorityToReview()"
    >
      <i-lucide name="triangle-alert" [size]="16"></i-lucide>
    </button>
    <button
      pButton
      type="button"
      label="Catégorie PM03"
      class="p-button-sm !bg-gray-500/80 !border-gray-500/80 hover:!bg-gray-500/80"
      (click)="filterByPM03Category()"
    >
      <i-lucide name="folder" [size]="16"></i-lucide>
    </button>
  </div>

  <div class="flex gap-2">
    <button
      pButton
      type="button"
      label="Exporter les priorités"
      icon="pi pi-download"
      class="p-button-sm !bg-red-500 !border-red-500 hover:!bg-red-600"
      (click)="exportPriorities()"
      [loading]="exportLoading"
    ></button>

    <button
      pButton
      type="button"
      label="Exporter les doublons"
      icon="pi pi-download"
      class="p-button-sm !bg-cyan-500 !border-cyan-500 hover:!bg-cyan-600"
      (click)="exportDuplicates()"
      [loading]="exportDuplicatesLoading"
    ></button>

    <div
      class="flex items-center justify-center gap-2 px-4 py-1 rounded-lg border shadow-sm"
    >
      <p-toggleswitch
        [(ngModel)]="rightPanelOpen"
        class="flex items-center"
      ></p-toggleswitch>
      <label class="text-sm font-medium">Ouvrir le panneau de détails</label>
    </div>
  </div>
</div>

<div class="relative pb-50">
  <div
    class="w-full bg-white dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-600"
  >
    <p-table
      #workOrderTable
      [value]="workOrders"
      [lazy]="true"
      [filters]="initialFilters"
      [loading]="loading"
      (onLazyLoad)="loadData($event)"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50, 100]"
      [paginator]="true"
      [rows]="25"
      currentPageReportTemplate="Éléments de {first} a {last} sur un total de {totalRecords}"
      selectionMode="single"
      [(selection)]="selectedOrder"
      dataKey="SAP_WorkOrderId"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Numéro">Numéro</span>
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_WorkOrderId"
                  field="SAP_WorkOrderId"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  [field]="filterFields.WORK_ORDER_ID"
                  matchMode="contains"
                  class="small-filter-input"
                  placeholder="Filtrer par numéro"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Poste de travail"
                  >Poste de travail</span
                >
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_MainWorkCenter"
                  field="SAP_MainWorkCenter"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.MAIN_WORK_CENTER"
                  [showMenu]="false"
                  matchMode="contains"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-multiselect
                      [options]="mainWorkCenterOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedMainWorkCenters"
                      (onChange)="
                        onMainWorkCenterFilterChange($event.value, filter)
                      "
                      (onClear)="onMainWorkCenterFilterChange(null, filter)"
                      placeholder="Filtrer par poste de travail"
                      [filter]="true"
                      filterPlaceholder="Rechercher..."
                      [showClear]="true"
                      appendTo="body"
                      size="small"
                    ></p-multiselect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>
          <th class="w-[12%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Poste Tech">Poste Tech</span>
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_FunctionalLocationDescription"
                  field="SAP_FunctionalLocationDescription"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  matchMode="contains"
                  [field]="filterFields.FUNCTIONAL_LOCATION"
                  class="small-filter-input"
                  placeholder="Filtrer par poste tech"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>
          <th class="w-[10%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Poste Tech Id"
                  >Poste Tech Id</span
                >
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_FunctionalLocation"
                  field="SAP_FunctionalLocation"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  matchMode="contains"
                  [field]="filterFields.FUNCTIONAL_LOCATION_ID"
                  class="small-filter-input"
                  placeholder="Filtrer par poste tech Id"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>
          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Date de création"
                  >Date de création</span
                >
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_CreatedOn"
                  field="SAP_CreatedOn"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.CREATED_ON"
                  [showMenu]="false"
                  [showClearButton]="false"
                  dataType="date"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-applyFilter="filterCallback"
                  >
                    <p-datepicker
                      placeholder="Filtrer par date de creation"
                      [style]="{
                        width: '100%',
                        padding: '0',
                      }"
                      [(ngModel)]="createdOnDate"
                      (ngModelChange)="applyFilter($event)"
                      size="small"
                      class="text-sm"
                      iconDisplay="button"
                      styleClass="text-sm p-inputtext-sm"
                      selectionMode="range"
                      showIcon
                      [showButtonBar]="true"
                    >
                    </p-datepicker>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Date d'échéance d'origine"
                  >Date d'échéance d'origine</span
                >
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_OriginalDueDate"
                  field="SAP_OriginalDueDate"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.ORIGINAL_DUE_DATE"
                  [showMenu]="false"
                  [showClearButton]="false"
                  dataType="date"
                  matchMode="equals"
                >
                  <ng-template
                    pTemplate="filter"
                    let-value
                    let-applyFilter="filterCallback"
                  >
                    <p-datepicker
                      placeholder="Filtrer par date d'échéance d'origine"
                      [style]="{
                        width: '100%',
                        padding: '0',
                      }"
                      (ngModelChange)="applyFilter($event)"
                      [(ngModel)]="originalDueDate"
                      size="small"
                      showIcon
                      class="text-sm"
                      styleClass="text-sm p-inputtext-sm"
                      selectionMode="range"
                      [showButtonBar]="true"
                    >
                    </p-datepicker>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[7%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Priorité">Priorité</span>
                <div class="flex items-center gap-1 flex-shrink-0">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-info-circle"
                    class="p-button-text p-button-sm !p-0 !h-auto !min-h-0 !w-auto leading-none"
                    (click)="prioritySettingsPopover.toggle($event)"
                  ></button>
                  <p-sortIcon
                    pSortableColumn="SAP_Priority"
                    field="SAP_Priority"
                  />
                </div>
              </div>
              <div class="mt-2 w-full">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.PRIORITY"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="priorityFilterOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedPriority"
                      (onChange)="filter($event.value)"
                      placeholder="Filtrer par priorité"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[13%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Description">Description</span>
                <p-sortIcon
                  class="flex-shrink-0"
                  pSortableColumn="SAP_Description"
                  field="SAP_Description"
                />
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  [showClearButton]="false"
                  type="text"
                  [field]="filterFields.DESCRIPTION"
                  class="small-filter-input"
                  matchMode="contains"
                  placeholder="Filtrer par description"
                  [style]="{ width: '100%' }"
                  size="small"
                >
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[10%] overflow-hidden">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Ordres Similaires"
                  >Ordres Similaires</span
                >
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.DUPLICATES"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="similarOrderFilterOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedSimilarOrderFilter"
                      (onChange)="
                        onSimilarOrderFilterChange($event.value, filter)
                      "
                      (onClear)="onSimilarOrderFilterChange(null, filter)"
                      placeholder="Filtrer par Ordres Similaires"
                      [showClear]="true"
                      appendTo="body"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>

          <th class="w-[8%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Categorie">Categorie</span>
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.WORK_ORDER_TYPE"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="workOrderTypeFilterOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedWorkOrderTypeFilter"
                      (onChange)="filter($event.value)"
                      placeholder="Filtrer par catégorie"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>
          <th class="w-[6%]">
            <div class="flex flex-wrap items-center justify-center w-full">
              <div
                class="flex items-center justify-between w-full overflow-hidden"
              >
                <span class="truncate" title="Statut utilisateur"
                  >Statut utilisateur</span
                >
              </div>
              <div class="mt-2 w-full mt-2">
                <p-columnFilter
                  class="ml-auto column-filter-full-width"
                  [field]="filterFields.USER_STATUS"
                  [showMenu]="false"
                  [showClearButton]="false"
                >
                  <ng-template
                    #filter
                    pTemplate="filter"
                    let-value
                    let-filter="filterCallback"
                  >
                    <p-select
                      [options]="userStatusOptions"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="selectedUserStatus"
                      (onChange)="filter($event.value)"
                      placeholder="Filtrer par catégorie"
                      size="small"
                    ></p-select>
                  </ng-template>
                </p-columnFilter>
              </div>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-order>
        <tr [pSelectableRow]="order">
          <td>{{ order?.SAP_WorkOrderId }}</td>
          <td>{{ order?.SAP_MainWorkCenter }}</td>
          <td>{{ order?.SAP_FunctionalLocationDescription }}</td>
          <td>{{ order?.SAP_FunctionalLocation }}</td>
          <td>
            <span
              tooltipStyleClass="tooltip-top"
              class="px-4 py-1.5 rounded-full"
              [ngClass]="{
                'bg-red-400 text-white text-sm font-semibold': order.IsOld,
              }"
            >
              {{ order?.SAP_CreatedOn | date: "yyyy/MM/dd" }}
            </span>
          </td>
          <td>{{ order?.SAP_OriginalDueDate | date: "yyyy/MM/dd" : "UTC" }}</td>
          <td class="text-center !p-0">
            <div class="inline-flex items-center gap-1 justify-center">
              <div
                *ngFor="let priority of ['A', 'B', 'C']"
                class="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold transition-all duration-200 shadow-sm cursor-pointer"
                [ngClass]="getPriorityBadgeClass(order, priority)"
                (click)="onPrioritySelect(order, priority, $event)"
              >
                {{ priority }}
              </div>
              <div
                class="inline-flex items-center justify-center w-5 h-5 rounded-full text-white rounded-full text-sm font-bold transition-all duration-200 shadow-sm cursor-pointer"
                [ngClass]="
                  order?.SelectedPriority ? 'bg-green-500' : 'bg-gray-400/70'
                "
                (mouseenter)="onSuggestedPriorityHover(order, $event)"
                (mouseleave)="onSuggestedPriorityLeave()"
              >
                {{ order?.SelectedPriority || "!" }}
              </div>
            </div>
          </td>
          <td>{{ order?.SAP_Description }}</td>
          <td class="overflow-hidden">
            <div
              *ngIf="order.SimilarWorkOrders?.length > 0"
              class="flex flex-wrap gap-1"
            >
              <div
                *ngFor="let similar of order.SimilarWorkOrders"
                class="relative inline-flex items-center"
              >
                <span
                  class="inline-flex items-center px-3.5 py-1 rounded-full text-sm font-semibold cursor-pointer transition-all duration-200 text-white box-content"
                  [ngClass]="[
                    getSimilarityScoreClass(similar?.SimilarityScore),
                    similar.IsSelected
                      ? 'border-2 border-red-800'
                      : 'border-2 border-transparent',
                  ]"
                  (mouseenter)="onSimilarOrderHover(similar, $event)"
                  (mouseleave)="onSimilarOrderLeave()"
                  (click)="onSimilarOrderSelect(order, similar, $event)"
                >
                  {{ similar.Similar_SAP_WorkOrderId }}
                </span>
                <div
                  *ngIf="similar.IsSelected"
                  class="absolute -top-1 -right-1 w-5 h-5 bg-red-800 rounded-full flex items-center justify-center shadow-lg border-2 border-white"
                >
                  <lucide-icon
                    name="x"
                    [size]="12"
                    class="text-white"
                  ></lucide-icon>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="flex items-center gap-1">
              <span
                class="px-3.5 py-1 rounded-full text-sm font-semibold bg-gray-400 text-white flex-shrink-0 border-2 border-transparent box-border"
              >
                {{ order.SAP_WorkOrderType }}
              </span>

              <div
                *ngFor="let category of order?.SuggestedCategories"
                class="flex items-center gap-1 flex-shrink-0"
              >
                <span class="text-gray-400 text-2xl font-bold leading-none"
                  >»</span
                >
                <div class="relative inline-flex items-center">
                  <span
                    [pTooltip]="
                      'Catégorie suggérée: ' +
                      category?.SuggestedCategory +
                      ' (Confiance: ' +
                      (category?.ConfidenceScore * 100 | number: '1.0-0') +
                      '%)'
                    "
                    tooltipPosition="left"
                    class="px-3 py-1 rounded-full text-sm font-semibold cursor-pointer transition-all duration-200 text-white box-border"
                    [ngClass]="[
                      getSimilarityScoreClass(category?.ConfidenceScore),
                      category.IsSelected
                        ? 'border-2 border-green-500'
                        : 'border-2 border-transparent',
                    ]"
                    (click)="onCategorySelect(order, category, $event)"
                  >
                    {{ category?.SuggestedCategory }}
                  </span>
                  <div
                    *ngIf="category.IsSelected"
                    class="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full flex items-center justify-center shadow-lg border-2 border-white"
                  >
                    <lucide-icon
                      name="check"
                      [size]="12"
                      class="text-white"
                    ></lucide-icon>
                  </div>
                </div>
              </div>

              <!-- <div
              *ngIf="order?.SuggestedCategories?.length > 0"
              class="inline-flex items-center justify-center w-6 h-6 rounded-full text-white text-sm font-bold transition-all duration-200 shadow-sm cursor-pointer"
              [ngClass]="order?.SelectedCategory ? 'bg-green-500' : 'bg-gray-400/70'"
            >
              {{ order?.SelectedCategory || "!" }}
            </div> -->
            </div>
          </td>
          <td class="text-center">
            <div class="inline-flex items-center justify-center">
              <span
                class="px-4 py-1.5 rounded-full text-sm font-semibold text-white"
                [ngClass]="getUserStatusClass(order.UserStatus)"
              >
                {{ order.UserStatus || "-" }}
              </span>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div
    *ngIf="rightPanelOpen"
    @slidePanel
    class="absolute right-0 h-full w-1/4 top-[80px] bottom-0 z-[0]"
  >
    <div
      class="sticky top-[130px] min-h-[200px] h-[calc(100vh-130px)] bg-white dark:bg-zinc-800 rounded-lg border border-gray-200 dark:border-zinc-600 flex flex-col shadow-lg"
    >
      <div class="flex-1 overflow-y-auto p-4">
        <div *ngIf="selectedOrder" class="space-y-4">
          <!-- Work Order Info -->
          <div
            class="bg-white dark:bg-zinc-900 rounded-lg border border-gray-200 dark:border-zinc-700 shadow-md p-4"
          >
            <div
              class="flex items-center justify-between mb-3 pb-3 border-b border-gray-200 dark:border-zinc-700"
            >
              <h4 class="text-sm font-bold text-gray-700 dark:text-gray-200">
                Ordre de travail
              </h4>
              <span class="text-sm font-bold text-gray-900 dark:text-gray-100">
                {{ selectedOrder.SAP_WorkOrderId }}
              </span>
            </div>
            <div>
              <h4
                class="text-sm font-bold text-gray-700 dark:text-gray-200 mb-2"
              >
                Description
              </h4>
              <p
                class="text-sm text-gray-900 dark:text-gray-100 font-semibold leading-relaxed"
              >
                {{ selectedOrder.SAP_Description }}
              </p>
            </div>
          </div>

          <!-- Priority Section -->
          <div
            class="bg-white dark:bg-zinc-900 rounded-lg border border-gray-200 dark:border-zinc-700 shadow-md p-4"
          >
            <h4
              class="text-sm font-bold text-gray-700 dark:text-gray-200 mb-4 pb-3 border-b border-gray-200 dark:border-zinc-700"
            >
              Priorités
            </h4>

            <div
              *ngIf="selectedOrder.UserStatus !== 'OPEN'"
              class="mb-4 p-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg"
            >
              <div class="flex items-start gap-2">
                <lucide-icon
                  name="triangle-alert"
                  [size]="18"
                  class="text-orange-500 flex-shrink-0 mt-0.5"
                ></lucide-icon>
                <p
                  class="text-sm text-orange-700 dark:text-orange-300 text-justify"
                >
                  Cet ordre de travail n'est pas ouvert (statut:
                  <strong>{{ selectedOrder.UserStatus }}</strong
                  >). La modification de la priorité n'est possible que pour les
                  ordres avec le statut <strong>OPEN</strong>.
                </p>
              </div>
            </div>

            <div class="grid grid-cols-3 gap-2 mb-4">
              <div class="flex flex-col items-center gap-1">
                <span
                  class="inline-flex items-center justify-center w-10 h-10 rounded-full text-sm font-bold bg-blue-500/70 text-white shadow-sm"
                >
                  {{ selectedOrder.SAP_Priority || "-" }}
                </span>
                <div class="text-center">
                  <div
                    class="text-xs font-semibold text-gray-700 dark:text-gray-300"
                  >
                    SAP
                  </div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    Actuelle
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center gap-1">
                <span
                  class="inline-flex items-center justify-center w-10 h-10 rounded-full text-sm font-bold bg-red-400/90 text-white shadow-sm"
                >
                  {{ selectedOrder.SuggestedPriority || "-" }}
                </span>
                <div class="text-center">
                  <div
                    class="text-xs font-semibold text-gray-700 dark:text-gray-300"
                  >
                    Proposée
                  </div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    Système
                  </div>
                </div>
              </div>
              <div class="flex flex-col items-center gap-1">
                <span
                  class="inline-flex items-center justify-center w-10 h-10 rounded-full text-sm font-bold bg-green-500 text-white shadow-sm"
                >
                  {{ selectedOrder.SelectedPriority || "-" }}
                </span>
                <div class="text-center">
                  <div
                    class="text-xs font-semibold text-gray-700 dark:text-gray-300"
                  >
                    Sélectionnée
                  </div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">
                    {{
                      selectedOrder.SelectedPriority
                        ? "Utilisateur"
                        : "Non définie"
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div class="pt-3 border-t border-gray-200 dark:border-zinc-700">
              <p
                class="text-base text-gray-700 dark:text-gray-100 leading-relaxed text-justify"
              >
                {{
                  selectedOrder.SuggestedPriorityExplanation ||
                    "La vérification des priorités n'a pas été exécutée pour cet ordre de travail."
                }}
              </p>
            </div>
          </div>
        </div>

        <p
          *ngIf="!selectedOrder"
          class="text-gray-600 dark:text-gray-400 text-center py-8"
        >
          Sélectionnez un ordre de travail
        </p>
      </div>
    </div>
  </div>
</div>

<p-popover
  #priorityPopover
  [dismissable]="true"
  [autoZIndex]="true"
  (onShow)="onPriorityPopoverShow()"
  (onHide)="onPriorityPopoverHide()"
>
  <div class="max-w-md p-4" *ngIf="selectedOrderForPriority">
    <div
      *ngIf="selectedOrderForPriority.UserStatus !== 'OPEN'"
      class="mb-4 p-3 bg-orange-50 dark:bg-orange-900/20 border border-orange-200 dark:border-orange-800 rounded-lg"
    >
      <div class="flex items-start gap-2">
        <lucide-icon
          name="triangle-alert"
          [size]="18"
          class="text-orange-500 flex-shrink-0 mt-0.5"
        ></lucide-icon>
        <p class="text-sm text-orange-700 dark:text-orange-300 text-justify">
          Cet ordre de travail n'est pas ouvert (statut:
          <strong>{{ selectedOrderForPriority.UserStatus }}</strong
          >). La modification de la priorité n'est possible que pour les ordres
          avec le statut <strong>OPEN</strong>.
        </p>
      </div>
    </div>
    <div class="grid grid-cols-3 gap-2 mb-4">
      <div class="flex flex-col items-center gap-1">
        <span
          class="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold bg-blue-500/70 text-white shadow-sm"
          >{{ selectedOrderForPriority.SAP_Priority || "-" }}</span
        >
        <div class="text-center">
          <div class="text-xs font-semibold text-gray-700 dark:text-gray-300">
            Priorité SAP
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400">Actuelle</div>
        </div>
      </div>
      <div class="flex flex-col items-center gap-1">
        <span
          class="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold bg-red-400/90 text-white shadow-sm"
          >{{ selectedOrderForPriority.SuggestedPriority || "-" }}</span
        >
        <div class="text-center">
          <div class="text-xs font-semibold text-gray-700 dark:text-gray-300">
            Priorité proposée
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400">
            Par le système
          </div>
        </div>
      </div>
      <div class="flex flex-col items-center gap-1">
        <span
          class="inline-flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold bg-green-500 text-white shadow-sm"
          >{{ selectedOrderForPriority.SelectedPriority || "-" }}</span
        >
        <div class="text-center">
          <div class="text-xs font-semibold text-gray-700 dark:text-gray-300">
            Priorité sélectionnée
          </div>
          <div class="text-xs text-gray-500 dark:text-gray-400">
            {{
              selectedOrderForPriority.SelectedPriority
                ? "Par l'utilisateur"
                : "Non définie"
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="border-t border-gray-200 dark:border-gray-600 pt-3">
      <div class="flex items-start gap-2">
        <p
          class="text-[12px] text-gray-700 dark:text-gray-100 leading-relaxed text-justify"
        >
          {{
            selectedOrderForPriority.SuggestedPriorityExplanation ||
              "La vérification des priorités n'a pas été exécutée pour cet ordre de travail."
          }}
        </p>
      </div>
    </div>
  </div>
</p-popover>

<p-popover
  #similarPopover
  [dismissable]="true"
  [autoZIndex]="true"
  (onShow)="onSimilarPopoverShow()"
  (onHide)="onSimilarPopoverHide()"
>
  <div class="min-w-80">
    <div *ngIf="selectedSimilarOrder" class="pt-3">
      <div class="mb-4">
        <div class="flex items-center gap-2 mb-2">
          <h4 class="text-sm font-bold text-gray-700 dark:text-gray-200">
            Ordre source:
          </h4>
          <div class="text-sm font-bold text-gray-900 dark:text-gray-100">
            {{ selectedSimilarOrder.Source_SAP_WorkOrderId }}
          </div>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400"
            >Date de création:</span
          >
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            getParentWorkOrder(selectedSimilarOrder.Source_SAP_WorkOrderId)
              ?.SAP_CreatedOn | date: "yyyy/MM/dd"
          }}</span>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400">Date d'échéance:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            getParentWorkOrder(selectedSimilarOrder.Source_SAP_WorkOrderId)
              ?.SAP_OriginalDueDate | date: "yyyy/MM/dd" : "UTC"
          }}</span>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400">Groupe:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            getParentWorkOrder(selectedSimilarOrder.Source_SAP_WorkOrderId)
              ?.SAP_Group || "N/A"
          }}</span>
        </div>
        <div class="text-xs mb-2">
          <span class="text-gray-600 dark:text-gray-400"
            >Compteur de groupe:</span
          >
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            getParentWorkOrder(selectedSimilarOrder.Source_SAP_WorkOrderId)
              ?.SAP_GroupCounter || "N/A"
          }}</span>
        </div>
        <div class="text-xs">
          <span class="text-gray-600 dark:text-gray-400">Description:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            getParentWorkOrder(selectedSimilarOrder.Source_SAP_WorkOrderId)
              ?.SAP_Description || "N/A"
          }}</span>
        </div>
      </div>

      <div class="border-t border-gray-300 dark:border-gray-600 my-3"></div>
      <div class="mb-4">
        <div class="flex items-center gap-2 mb-2">
          <h4 class="text-sm font-bold text-gray-700 dark:text-gray-200">
            Ordre similaire:
          </h4>
          <div class="text-sm font-bold text-gray-900 dark:text-gray-100">
            {{ selectedSimilarOrder.Similar_SAP_WorkOrderId }}
          </div>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400">Status:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            selectedSimilarOrder.SimilarTo.CalculatedStatus ? "Fermé" : "Ouvert"
          }}</span>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400"
            >Date de création:</span
          >
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            selectedSimilarOrder.SimilarTo.SAP_CreatedOn | date: "yyyy/MM/dd"
          }}</span>
        </div>
        <div class="text-xs mb-1">
          <span class="text-gray-600 dark:text-gray-400">Groupe:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            selectedSimilarOrder.SimilarTo.SAP_Group || "N/A"
          }}</span>
        </div>
        <div class="text-xs mb-2">
          <span class="text-gray-600 dark:text-gray-400"
            >Compteur de groupe:</span
          >
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            selectedSimilarOrder.SimilarTo.SAP_GroupCounter || "N/A"
          }}</span>
        </div>
        <div class="text-xs">
          <span class="text-gray-600 dark:text-gray-400">Description:</span>
          <span class="text-gray-900 dark:text-gray-100 font-medium ml-1">{{
            selectedSimilarOrder.SimilarTo.SAP_Description
          }}</span>
        </div>
      </div>

      <div class="border-t border-gray-300 dark:border-gray-600 my-3"></div>

      <div class="flex items-center justify-between mb-3">
        <span class="text-xs font-semibold text-gray-500 dark:text-gray-400"
          >Score de similarité:</span
        >
        <div
          class="inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-bold transition-colors duration-200 text-white"
          [ngClass]="
            getSimilarityScoreClass(selectedSimilarOrder.SimilarityScore)
          "
        >
          {{ selectedSimilarOrder.SimilarityScore * 100 | number: "1.0-0" }}%
        </div>
      </div>

      <div class="flex items-center justify-between">
        <span class="text-xs font-semibold text-gray-500 dark:text-gray-400"
          >État de sélection:</span
        >
        <div
          class="inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-bold transition-colors duration-200 text-white"
          [ngClass]="
            selectedSimilarOrder.IsSelected ? 'bg-green-500' : 'bg-red-500'
          "
        >
          {{ selectedSimilarOrder.IsSelected ? "Retenu" : "Non retenu" }}
        </div>
      </div>
    </div>
  </div>
</p-popover>

<p-popover #prioritySettingsPopover [dismissable]="true" [autoZIndex]="true">
  <div class="p-4 min-w-96">
    <h4 class="text-base font-semibold text-gray-700 dark:text-gray-200 mb-3">
      Légende des priorités
    </h4>
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <div class="w-6 h-6 rounded-full bg-blue-500 flex-shrink-0"></div>
        <span class="text-base text-gray-700 dark:text-gray-300"
          >Priorité actuelle dans SAP</span
        >
      </div>
      <div class="flex items-center gap-2">
        <div class="w-6 h-6 rounded-full bg-red-400 flex-shrink-0"></div>
        <span class="text-base text-gray-700 dark:text-gray-300"
          >Priorité suggérée par l'IA</span
        >
      </div>
      <div class="flex items-center gap-2">
        <div class="w-6 h-6 rounded-full bg-gray-300 flex-shrink-0"></div>
        <span class="text-base text-gray-700 dark:text-gray-300"
          >Priorité non sélectionnée</span
        >
      </div>
      <div class="flex items-center gap-2">
        <div
          class="w-6 h-6 rounded-full bg-gray-400 text-white flex items-center justify-center text-xs font-bold flex-shrink-0"
        >
          !
        </div>
        <span class="text-base text-gray-700 dark:text-gray-300"
          >Suggestion de priorité</span
        >
      </div>

      <div class="flex items-center gap-2">
        <div
          class="w-6 h-6 rounded-full bg-green-500 text-white flex items-center justify-center text-xs font-bold flex-shrink-0"
        ></div>
        <span class="text-base text-gray-700 dark:text-gray-300"
          >Priorité sélectionnée par l'utilisateur</span
        >
      </div>
    </div>
  </div>
</p-popover>
